export class GameTableEvents
{
    static ZOOM: string = 'GameTableEvents.ZOOM';
    static POSITION_AND_SCALE: string = 'GameTableEvents.POSITION_AND_SCALE';
}
